import React from 'react';
import CTA from '../../pages/home/CtaSection';

import serviceImg1 from '../../assets/img/slider/gemasan-12.svg';
import serviceImg2 from '../../assets/img/slider/gemasan-12.svg';

const ServiceDetailsNavigationMain = () => {

  return (
    <main>
      {/* Intro Text Section */}
      <div className="intro-text-section" style={{
        padding: 'clamp(120px, 15vw, 200px) 0 clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontSize: 'clamp(32px, 5vw, 56px)',
            fontWeight: '700',
            color: '#14105B',
            marginBottom: 'clamp(20px, 3vw, 30px)',
            lineHeight: '1.2',
            letterSpacing: '-0.5px'
          }}>
            Gözcü Seyir Destek Sistemi
          </h1>
          <p style={{
            fontSize: 'clamp(16px, 2vw, 20px)',
            lineHeight: '1.7',
            color: '#14105B',
            marginBottom: 'clamp(30px, 4vw, 40px)',
            maxWidth: '800px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            Deniz taşımacılığında artan trafik yoğunluğu, insan kaynağı kısıtları ve güvenlik riskleri; yeni nesil otonom destek sistemlerine olan ihtiyacı her geçen gün artırmaktadır. Gözcü Seyir Destek Sistemi, deniz araçlarının güvenli ve verimli şekilde seyir yapabilmesi için yapay zekâ tabanlı gözlem, durumsal farkındalık ve nesne tespiti yeteneklerine sahip otonom bir karar destek altyapısı sunar. Gündüz ve gece koşullarında çalışan kamera ve sensörlerden aldığı verileri gerçek zamanlı işleyerek çevresel farkındalık oluşturur, nesne tespiti ve takibi ile olası çarpışma risklerini önceden belirler ve rota optimizasyonu sayesinde gemilerin daha hızlı, güvenli ve tasarruflu seyir yapmasına katkı sağlar. Böylece mürettebatın iş yükünü azaltır, insan kaynaklı hata riskini en aza indirir, bakım süreçlerini destekler ve uluslararası standartlarla uyumlu, gemilere entegre edilebilir modern bir seyir destek çözümü sunar.
          </p>
          <a
            href="/iletisim"
            style={{
              display: 'inline-block',
              padding: 'clamp(12px, 1.5vw, 16px) clamp(30px, 4vw, 40px)',
              fontSize: 'clamp(14px, 1.8vw, 18px)',
              fontWeight: '600',
              color: '#14105B',
              backgroundColor: 'transparent',
              border: '1px solid #14105B',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textTransform: 'none',
              letterSpacing: '0.5px',
              textDecoration: 'none'
            }}
          >
            Demo Talep Et
          </a>
        </div>
      </div>

      <div className="middle-wrapper" style={{
        padding: 'clamp(40px, 8vw, 140px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div className="screen-and-text" style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'clamp(30px, 5vw, 80px)',
            flexWrap: 'wrap',
          }}>
            <div className="screen-wrapper" style={{
              flex: '1 1 50%',
              minWidth: 'min(100%, 400px)',
              maxWidth: '700px'
            }}>
              <div className="rec" style={{
                position: 'relative',
                width: '100%',
                backgroundColor: '#f5f5f5',
                borderRadius: 'clamp(12px, 2vw, 20px)',
                padding: 'clamp(6px, 1.2vw, 16px)',
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: '100%',
                  paddingBottom: '56.25%',
                  position: 'relative',
                  backgroundColor: '#e8e8e8',
                  borderRadius: 'clamp(8px, 1.5vw, 12px)',
                  overflow: 'hidden'
                }}>
                  <img
                    src="/ana_ekran.svg"
                    alt="Seyir Sistemi"
                    style={{
                      position: 'absolute',
                      top: '0',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="text-wrapper" style={{
              flex: '1 1 40%',
              minWidth: 'min(100%, 300px)',
              maxWidth: '550px',
              paddingTop: '0',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start'
            }}>
              <p className="title wow fadeInUp" style={{
                fontSize: 'clamp(12px, 1.2vw, 15px)',
                color: '#14105B',
                marginBottom: 'clamp(8px, 1.5vw, 16px)',
                fontWeight: '500',
                letterSpacing: '0.3px',
                marginTop: '0'
              }}>
                Dashboard Ekranı
              </p>
              <h2 className="wow fadeInUp" data-wow-delay=".2s" style={{
                fontSize: 'clamp(20px, 3.5vw, 42px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2.5vw, 24px)',
                lineHeight: '1.2',
                letterSpacing: '-0.3px',
                marginTop: '0'
              }}>
                Tüm Veriler Tek Bir <span className="nowrap-text">Dashboard'da</span>
              </h2>
              <p className="wow fadeInUp" data-wow-delay=".4s" style={{
                fontSize: 'clamp(13px, 1.6vw, 17px)',
                lineHeight: '1.65',
                color: '#333333',
                marginBottom: '0',
                fontWeight: '400',
                marginTop: '0'
              }}>
                Gözcü Seyir Destek Sistemi’nin dashboard ekranı, tüm bu verileri tek bir sezgisel arayüzde toplayarak kaptana “köprüde tam otomatik gözcü” kazandırır. Yapay zekâ tabanlı analiz motoru; kameralar, sensörler ve seyir ekipmanlarından gelen verileri gerçek zamanlı olarak işler, riskleri önceliklendirir, görsel uyarılar ve rota önerileriyle durumsal farkındalığı sürekli yüksek tutar. Böylece mürettebat, dağınık ekranlar yerine tek bir kontrol paneli üzerinden güvenle ve hızla karar verebilir.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="items-wrapper" style={{
        padding: 'clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff',
        marginTop: '0'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div className="items-container" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 'clamp(30px, 4vw, 60px)',
            position: 'relative'
          }}>
            {/* Divider lines */}
            <div className="items-divider items-divider-1"></div>
            <div className="items-divider items-divider-2"></div>

            {/* Item 1 */}
            <div className="item one wow fadeInRight" style={{
              padding: '0 clamp(15px, 2vw, 30px)'
            }}>
              <div className="icon-wrapper" style={{
                marginBottom: 'clamp(20px, 3vw, 30px)',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}>
                {/* SVG görselinizi buraya ekleyin */}
                <img
                  src="/seyir-1.svg"
                  alt="Durumsal Farkındalık"
                  style={{
                    width: 'clamp(40px, 5vw, 50px)',
                    height: 'auto',
                    flexShrink: 0,
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h3 style={{
                fontSize: 'clamp(18px, 2.5vw, 24px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2vw, 18px)',
                lineHeight: '1.3'
              }}>
                Durumsal Farkındalığı Artırın
              </h3>
              <p style={{
                fontSize: 'clamp(14px, 1.6vw, 16px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Gelişmiş algılama ve analiz kabiliyeti sayesinde, en karmaşık deniz trafiği senaryolarını bile 7/24 izleyin, sınıflandırın ve önceliklendirin. Böylece köprüüstünde neler olup bittiğine dair tam ve güncel bir durumsal farkındalık seviyesine her an sahip olun.
              </p>
            </div>

            {/* Item 2 */}
            <div className="item two wow fadeInRight" data-wow-delay=".2s" style={{
              padding: '0 clamp(15px, 2vw, 30px)'
            }}>
              <div className="icon-wrapper" style={{
                marginBottom: 'clamp(20px, 3vw, 30px)',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}>
                {/* SVG görselinizi buraya ekleyin */}
                <img
                  src="/seyir-2.svg"
                  alt="İş Yükü"
                  style={{
                    width: 'clamp(40px, 5vw, 50px)',
                    height: 'auto',
                    flexShrink: 0,
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h3 style={{
                fontSize: 'clamp(18px, 2.5vw, 24px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2vw, 18px)',
                lineHeight: '1.3'
              }}>
                İş Yükünü Azaltın
              </h3>
              <p style={{
                fontSize: 'clamp(14px, 1.6vw, 16px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Otomatik nesne tespiti ve önceliklendirme süreci ile gemi kaptanlarının üzerindeki zihinsel yükü azaltın, karışıklığı ortadan kaldırın. Sistem, hangi hedefin ne kadar kritik olduğunu sizin yerinize değerlendirir; ekip ise enerjisini doğru zamanda doğru kararı vermeye odaklar.
              </p>
            </div>

            {/* Item 3 */}
            <div className="item three wow fadeInRight" data-wow-delay=".4s" style={{
              padding: '0 clamp(15px, 2vw, 30px)'
            }}>
              <div className="icon-wrapper" style={{
                marginBottom: 'clamp(20px, 3vw, 30px)',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}>
                {/* SVG görselinizi buraya ekleyin */}
                <img
                  src="/seyir-3.svg"
                  alt="Otomasyon"
                  style={{
                    width: 'clamp(40px, 5vw, 50px)',
                    height: 'auto',
                    flexShrink: 0,
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h3 style={{
                fontSize: 'clamp(18px, 2.5vw, 24px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(12px, 2vw, 18px)',
                lineHeight: '1.3'
              }}>
                İnsan Hatasını Azaltın
              </h3>
              <p style={{
                fontSize: 'clamp(14px, 1.6vw, 16px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Yapay zeka ve otomasyonu, ekibinizin yanında çalışan bir navigasyon asistanı gibi konumlandırarak denizde daha verimli, güvenli ve tutarlı kararlar alın. Sistem, insan hatasını en aza indirirken, mürettebatın deneyimini ve sezgilerini destekleyen ikinci bir güvenlik katmanı oluşturur.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Section 1: All marine object detection */}
      <div className="feature-section-1" style={{
        padding: 'clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'clamp(40px, 6vw, 80px)',
            alignItems: 'center'
          }}>
            {/* Left: Text */}
            <div className="text-part">
              <h3 style={{
                fontSize: 'clamp(24px, 3.5vw, 36px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(16px, 2.5vw, 24px)',
                lineHeight: '1.2'
              }}>
                Denizlerde Objelerin Tespiti
              </h3>
              <p style={{
                fontSize: 'clamp(15px, 1.8vw, 18px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Gözcü, gemi üzerindeki kameralar ve çeşitli sensörlerden topladığı verileri gerçek zamanlı olarak işleyerek görüş alanındaki tüm deniz objelerini tespit eder, izler ve sınıflandırır. Balıkçı tekneleri, yüzen konteynerler ve AIS yayını olmayan diğer hedefler dahil olmak üzere küçük hedefleri dahi uzun mesafelerde algılar; her bir hedef için rota, hız, CPA/TCPA ve SOG gibi seyir parametrelerini hesaplayarak risk seviyesini belirler. Bu bilgiler, ECDIS, ARPA radar ve köprüüstü alarm sistemleriyle entegre çalışabilen tek bir arayüz üzerinden gemi kaptanına önceliklendirilmiş uyarılar olarak sunulur.
              </p>
            </div>

            {/* Right: Simple Icon List */}
            <div className="diagram-part" style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              alignItems: 'flex-start',
              width: '100%'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '15px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: '1', minWidth: 0 }}>
                  {/* Görselinizi buraya ekleyin */}
                  <img
                    src="/gemi-1.svg"
                    alt="Gemiler"
                    style={{
                      width: 'clamp(32px, 4vw, 40px)',
                      height: 'auto',
                      flexShrink: 0,
                      objectFit: 'contain'
                    }}
                  />
                  <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>Gemiler</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#14105B', flexShrink: 0 }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span style={{ fontSize: 'clamp(11px, 1.3vw, 13px)', color: '#14105B', fontWeight: '600' }}>10NM</span>
                </div>
              </div>
              <div style={{ width: '100%', height: '1px', backgroundColor: '#e0e0e0' }}></div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '15px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: '1', minWidth: 0 }}>
                  {/* SVG görselinizi buraya ekleyin */}
                  <img
                    src="/gemi-2.svg"
                    alt="Canlılar"
                    style={{
                      width: 'clamp(32px, 4vw, 42px)',
                      height: 'auto',
                      flexShrink: 0,
                      objectFit: 'contain'
                    }}
                  />
                  <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>Canlılar</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#14105B', flexShrink: 0 }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span style={{ fontSize: 'clamp(11px, 1.3vw, 13px)', color: '#14105B', fontWeight: '600' }}>3.5NM</span>
                </div>
              </div>
              <div style={{ width: '100%', height: '1px', backgroundColor: '#e0e0e0' }}></div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '15px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: '1', minWidth: 0 }}>
                  {/* SVG görselinizi buraya ekleyin */}
                  <img
                    src="/gemi-3.svg"
                    alt="Yüzen Konteyner"
                    style={{
                      width: 'clamp(32px, 4vw, 53px)',
                      height: 'auto',
                      flexShrink: 0,
                      objectFit: 'contain'
                    }}
                  />
                  <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>Yüzen Konteyner</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#14105B', flexShrink: 0 }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span style={{ fontSize: 'clamp(11px, 1.3vw, 13px)', color: '#14105B', fontWeight: '600' }}>2NM</span>
                </div>
              </div>
              <div style={{ width: '100%', height: '1px', backgroundColor: '#e0e0e0' }}></div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '15px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: '1', minWidth: 0 }}>
                  {/* SVG görselinizi buraya ekleyin */}
                  <img
                    src="/gemi-4.svg"
                    alt="Şamandıra"
                    style={{
                      width: 'clamp(32px, 4vw, 40px)',
                      height: 'auto',
                      flexShrink: 0,
                      objectFit: 'contain'
                    }}
                  />
                  <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>Şamandıra</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#14105B', flexShrink: 0 }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span style={{ fontSize: 'clamp(11px, 1.3vw, 13px)', color: '#14105B', fontWeight: '600' }}>2NM</span>
                </div>
              </div>
              <div style={{ width: '100%', height: '1px', backgroundColor: '#e0e0e0' }}></div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '15px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: '1', minWidth: 0 }}>
                  {/* SVG görselinizi buraya ekleyin */}
                  <img
                    src="/gemi-5.svg"
                    alt="Balıkçı Teknesi"
                    style={{
                      width: 'clamp(32px, 4vw, 46px)',
                      height: 'auto',
                      flexShrink: 0,
                      objectFit: 'contain'
                    }}
                  />
                  <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: '#14105B' }}>Balıkçı Teknesi</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#14105B', flexShrink: 0 }}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span style={{ fontSize: 'clamp(11px, 1.3vw, 13px)', color: '#14105B', fontWeight: '600' }}>2NM</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Section 2: Alerts on high-risk marine targets */}
      <div className="feature-section-2" style={{
        padding: 'clamp(60px, 8vw, 100px) 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="content-wrapper" style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 clamp(15px, 4vw, 60px)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'clamp(40px, 6vw, 80px)',
            alignItems: 'center'
          }}>
            {/* Left: Alert Visual */}
            <div className="alert-visual-part" style={{
              position: 'relative',
              width: '100%',
              maxWidth: '500px',
              borderRadius: '12px',
              overflow: 'hidden',
              backgroundColor: '#f5f5f5'
            }}>
              <img
                src="/gemasan_yeni.gif"
                alt="Ship detection"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  borderRadius: '12px'
                }}
              />
            </div>

            {/* Right: Text */}
            <div className="text-part">
              <h3 style={{
                fontSize: 'clamp(24px, 3.5vw, 36px)',
                fontWeight: '700',
                color: '#14105B',
                marginBottom: 'clamp(16px, 2.5vw, 24px)',
                lineHeight: '1.2'
              }}>
                Gözcü ile Yüksek Riskli Hedeflere Erken Uyarı
              </h3>
              <p style={{
                fontSize: 'clamp(15px, 1.8vw, 18px)',
                lineHeight: '1.7',
                color: '#14105B',
                margin: '0'
              }}>
                Gözcü, geminin etrafındaki potansiyel tehlikeleri ve yüksek riskli hedefleri gerçek zamanlı olarak izler. CPA/TCPA, mesafe, göreceli hız ve rota sapması gibi seyir parametrelerini analiz ederek çarpışma, yakın geçiş veya rota ihlali gibi durumlar için erken uyarılar üretir ve bu uyarıları köprüüstü sistemleriyle entegre, anlaşılır bir arayüzde gemi kaptanına sunar.
              </p>
            </div>
          </div>
        </div>
      </div>


      <CTA />
    </main>
  );
};

export default ServiceDetailsNavigationMain;
